import * as React from 'react';
import { IFilter } from '@wyz/types';
import { Button, Flex, Icon, RowModel, Text, Tooltip } from '../index';
import { useDatatableContext } from './context';
type Props<TCriteria = IFilter> = {
  onExport?: (criteria: TCriteria) => void;
  exportDisabled?: boolean;
  exportDisabledTooltip?: React.ReactNode;
  exportInfoTooltip?: React.ReactNode;
};
const Header = <TDataItem extends RowModel, TCriteria = IFilter>({
  onExport,
  exportDisabled = false,
  exportDisabledTooltip,
  exportInfoTooltip,
  children,
}: React.PropsWithChildren<Props<TCriteria>>) => {
  const datatableContext = useDatatableContext<TDataItem>();
  const from = datatableContext.internals.query.data?.meta.from ?? 0;
  const to = datatableContext.internals.query.data?.meta.to ?? 0;
  const total = datatableContext.internals.query.data?.meta.total ?? 0;

  const exportButton = onExport ? (
    <Button
      id='export'
      variant='tertiary-blue'
      type='button'
      size='sm'
      disabled={exportDisabled}
      onClick={() => {
        const currentFormValue = datatableContext.internals.state
          .transformedCriteria as TCriteria;
        onExport?.(currentFormValue);
      }}
    >
      <span>{datatableContext.translations?.exportBtn ?? 'Export'}</span>
      <Icon icon='download' size='xs' />
    </Button>
  ) : null;
  return (
    <div className='my-3 d-flex align-items-center w-100'>
      <Flex alignItems='center' className='space-x-2'>
        <Text heading='normal' weight='semi-bold'>
          {datatableContext.translations?.pagination?.showingResult
            ? datatableContext.translations?.pagination?.showingResult({
                from,
                to,
                total,
              })
            : `${total} results`}
        </Text>
        {exportButton}
        {(exportDisabled ? exportDisabledTooltip : exportInfoTooltip) && (
          <Tooltip
            enabled
            label={exportDisabled ? exportDisabledTooltip : exportInfoTooltip}
          >
            <span>
              <Icon icon='information-line' size='xs' />
            </span>
          </Tooltip>
        )}
      </Flex>
      {children}
    </div>
  );
};

export default Header;
